var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolikuvitus128036(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6{fill:#fff;}.cls-7,.cls-8,.cls-9,.cls-10{fill:none;}.cls-7{opacity:0.2;}.cls-8,.cls-9{stroke:#6e6e6e;}.cls-8,.cls-9,.cls-10{stroke-linecap:round;stroke-width:1.25px;}.cls-8{stroke-miterlimit:10;}.cls-9,.cls-10{stroke-linejoin:round;}.cls-10{stroke:#ff6a10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M74.26,74.58a6.28,6.28,0,1,0,0,8.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 61.72,
    y1: 77.56,
    x2: 69.25,
    y2: 77.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 61.72,
    y1: 80.48,
    x2: 69.25,
    y2: 80.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.45,50.45h63A1.52,1.52,0,0,1,121.91,52v54.6a1.52,1.52,0,0,1-1.51,1.51H16.78a1.52,1.52,0,0,1-1.51-1.51V52a1.52,1.52,0,0,1,1.51-1.51H42.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 68.59,
    cy: 79.41,
    r: 19.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 68.59,
    cy: 79.41,
    r: 16.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 38.48,
    cy: 78.2,
    r: 1.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 98.7,
    cy: 78.2,
    r: 1.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.58,62.27s11,2.71,10.47-8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.58,95.77s11.76-2,11,9.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.6,62.27s-11.38,3.82-10.9-8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.6,95.3s-11-2.26-10.9,9.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 56.58,
    y1: 53.68,
    x2: 107.7,
    y2: 53.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 29.05,
    y1: 53.68,
    x2: 43.65,
    y2: 53.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 29.53,
    y1: 105.05,
    x2: 107.7,
    y2: 105.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 18.58,
    y1: 62.27,
    x2: 18.58,
    y2: 95.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 118.6,
    y1: 62.27,
    x2: 118.6,
    y2: 95.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.66,27.37V19.93L6.09,35.6,28.66,48.2v-7c23,0,22.21,23.76,5.43,26.74C58.21,68.75,66.79,29,28.66,27.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolikuvitus128036);
export default __webpack_public_path__ + "static/media/symbolikuvitus_128_036.72e8ad1b0c12fc73b6e1589cb0cbbefb.svg";
export { ForwardRef as ReactComponent };